import FormInputs from '../CreateFormInputMarsComplete.js'
import useFormContext from "../GetEventMarsComplete.jsx/useFormMarsComplete.js"
import Footer from '../FooterMarsComplete.js'

import Header from '../HeaderMarsComplete.js'
import RequestHeader from '../GetEventMarsComplete.jsx/RequestHeaderMarsComplete'
import { NavigationMarsComplete } from '../GetEventMarsComplete.jsx/NavigationMarsComplete.js'
import { useEffect } from 'react'
const GetEventdetailMarscomplete = () => {

    const {
        eventFormData,
        getEventById,
        handlepageChange,
        headerRefresh
    } = useFormContext()

    useEffect(() => {
        var res = window.location.href.split('/');
        eventFormData.eventId = res[res.length - 1]
        getEventById(eventFormData.eventId)
        if (res[res.length - 2] == 'guest') {
            handlepageChange(2);
        } else if (res[res.length - 2] == 'comment') {
            handlepageChange(3);
        } else if (res[res.length - 2] == 'postevent') {
            handlepageChange(4);
        }
    }, []);


    const content = (
        <form id="getDetailsAdminForm" className="form flex-col">
            <div>
                <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.8/dist/css/bootstrap.min.css" rel="stylesheet"
                    integrity="sha384-QWTKZyjpPEjISv5WaRU9OFeRpok6YctnYmDr5pNlyT2bRjXh0JMhjY6hW+ALEwIH" crossOrigin="anonymous"></link>
                <div className='container-fluid-custom'>
                    <Header key={headerRefresh} />
                    <RequestHeader />
                    <div className="container-fluid">
                        <div className="row m-1 mb-5">
                            <div className="col-md-2 p-0">
                                <NavigationMarsComplete />
                            </div>
                            <FormInputs />
                        </div>
                    </div>
                    <Footer hideButtons={true} />
                </div>
            </div>
        </form>
    )

    return content
}

export default GetEventdetailMarscomplete